import { PREDEFINED_TENANTS } from 'swag-common/constants/main-swag.constants';
export function checkIsResellerTenant(tenant = null) {
  if (!tenant) {
    return false;
  }
  return !Object.values(PREDEFINED_TENANTS).some(el => el === tenant);
}